import { api } from '@wellesley/openapi'

export const linksPreviewApi = api.enhanceEndpoints({
  endpoints: {
    getApiV1Links: {
      extraOptions: {
        maxRetries: 0,
      },
    },
  },
})

export const { useLazyGetApiV1LinksQuery } = linksPreviewApi
